import Cookies from "js-cookie";
import { takeEvery } from "typed-redux-saga";
import { storeIsLogged } from "../actions";

export default function* watchStoreIsLogged() {
  yield* takeEvery(storeIsLogged, function ({ payload }) {
    Cookies.set("is_logged", payload.isLogged ? "1" : "0");
  });
}
